import axios from "axios";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  name: "students",
  components: {},
  props: [],
  data() {
    return {
      //users: [],
      selectedItem: {},
      fields: [
        {
          key: "user",
          label: "Usuari",
        },
        {
          key: "deadlines",
          label: "Deadlines",
        },
        {
          key: "userName",
          label: "UserName",
          sortable: true,
        },
        {
          key: "team",
          label: "Team",
          sortable: true,
        },
        {
          key: "group",
          label: "Group",
          sortable: true,
        },
        {
          key: "roles",
          label: "Roles",
        },
        {
          key: "active",
          label: "Active",
        },
        {
          key: "actions",
          label: "Actions",
        },
      ],
    };
  },
  computed: {
    deadlines() {
      return this.$store.getters.getDeadlines;
    },
    users() {
      return this.$store.getters.getUsers;
    },
    roles() {
      return this.$store.getters.getRoles;
    },
  },
  beforeMount() {
    // axios.get("users?fields=roles,team").then(response => {
    //   this.users = response.data;
    // });
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Backend" },
      { title: "Users", route: "students" },
      { title: "Students" },
    ]);
  },
  methods: {
    getRoleInfo(r) {
      let role = this.roles.find((rol) => rol._id == r);
      return role?.name;
    },
    getInitials(u) {
      if (!u.avatar) {
        if (!u.firstName || !u.lastName) {
          return u.userName[0] + u.userName[1];
        } else {
          return u.firstName[0] + u.lastName[0];
        }
      }
    },
    updateActive(i) {
      axios
        .put("users/" + i._id, { isActive: !i.isActive })
        .then((response) => {
          console.log(response);
        });
    },
    deleteItem(id) {
      axios.delete("users/" + id).then((response) => {
        console.log(response);
        this.users.splice(
          this.users.findIndex((o) => o._id == id),
          1
        );
      });
    },
  },
};
